export const REMOVE_USER = "REMOVE_USER";
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";
export const SHOW_COUPON = "SHOW_COUPON";
export const SHOW_LEDGER = "SHOW_LEDGER";
export const BLOCK_USER = "BLOCK_USER";
